// extracted by mini-css-extract-plugin
export default {"container":"mL-z","modal":"nL-z","dimensions":"oL-z","brandName":"pL-z","productName":"qL-z","labelValue":"rL-z","recipientEmail":"sL-z","recommendedFit":"tL-z","hiddenField":"uL-z"};